module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    staticStyle: {
      "max-height": "80vh",
      "overflow-y": "scroll"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", [_vm._v("\n              SEO Details\n            ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", [_vm._v("\n              SEO Title\n              "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passedObject.podSeoTitle),
      expression: "passedObject.podSeoTitle"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.passedObject.podSeoTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.passedObject, "podSeoTitle", $event.target.value)
      }
    }
  })]), _vm._v("\n              SEO Description\n              "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passedObject.podSeoDesc),
      expression: "passedObject.podSeoDesc"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.passedObject.podSeoDesc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.passedObject, "podSeoDesc", $event.target.value)
      }
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": _vm.saveEpisodeSeo
    }
  }, [_vm._v("\n                SAVE\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": _vm.closeTheModal
    }
  }, [_vm._v("\n                CANCEL\n              ")])])], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26a1cff8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModalPodcast.vue
// module id = 635
// module chunks = 1